import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const Layout = ({ children, title = 'Klass Online | Login' }) => {
  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <main style={{ minHeight: '100vh' }}>{children}</main>
      </div>
    </HelmetProvider>
  );
};

export default Layout;
